
/*
Service to manage shift clicks on elements
 */
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('smart-table').factory('stShiftSort', function() {
  var clickedElements;
  clickedElements = [];
  return {
    getIndex: function(elementId) {
      return clickedElements.indexOf(elementId) + 1;
    },
    clickElement: function(elementId) {
      if (indexOf.call(clickedElements, elementId) < 0) {
        return clickedElements.push(elementId);
      }
    },
    clear: function() {
      return clickedElements.length = 0;
    }
  };
});

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2hvbWUvZG9vemVyL3Byb2plY3RzL3N0LW11bHRpLXNvcnQvc3JjL3N0X3NoaWZ0X2NsaWNrLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9ob21lL2Rvb3plci9wcm9qZWN0cy9zdC1tdWx0aS1zb3J0L3NyYy9zdF9zaGlmdF9jbGljay5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7QUFBQSxJQUFBOztBQUdBLE9BQU8sQ0FBQyxNQUFSLENBQWUsYUFBZixDQUVBLENBQUMsT0FGRCxDQUVTLGFBRlQsRUFFd0IsU0FBQTtBQUN0QixNQUFBO0VBQUEsZUFBQSxHQUFrQjtTQUVsQjtJQUNFLFFBQUEsRUFBVSxTQUFDLFNBQUQ7YUFDUixlQUFlLENBQUMsT0FBaEIsQ0FBd0IsU0FBeEIsQ0FBQSxHQUFxQztJQUQ3QixDQURaO0lBSUUsWUFBQSxFQUFjLFNBQUMsU0FBRDtNQUNaLElBQUcsYUFBaUIsZUFBakIsRUFBQSxTQUFBLEtBQUg7ZUFDRSxlQUFlLENBQUMsSUFBaEIsQ0FBcUIsU0FBckIsRUFERjs7SUFEWSxDQUpoQjtJQVFFLEtBQUEsRUFBTyxTQUFBO2FBQ0wsZUFBZSxDQUFDLE1BQWhCLEdBQXlCO0lBRHBCLENBUlQ7O0FBSHNCLENBRnhCIn0=
